import { render, staticRenderFns } from "./ADSpace.vue?vue&type=template&id=2d8c8fdc&scoped=true&"
import script from "./ADSpace.vue?vue&type=script&lang=js&"
export * from "./ADSpace.vue?vue&type=script&lang=js&"
import style0 from "./ADSpace.vue?vue&type=style&index=0&id=2d8c8fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c8fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8c8fdc')) {
      api.createRecord('2d8c8fdc', component.options)
    } else {
      api.reload('2d8c8fdc', component.options)
    }
    module.hot.accept("./ADSpace.vue?vue&type=template&id=2d8c8fdc&scoped=true&", function () {
      api.rerender('2d8c8fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/BaseInfoChildren/ADSpace.vue"
export default component.exports